// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const tasksClient = createTypedClient();
export const createTasksClient = (config) => createTypedClient(config);
